import fachadaImg from '../assets/front-QUIMSA.jpg';

const Club = () => {
  return (
    <>
      <div className="bg-gray-50 text-gray-800 pt-12 pb-20">
        <div className="max-w-5xl mx-auto px-6">
          <h1 className="text-4xl font-bold text-blue-900 mb-6 border-b-4 border-red-600 inline-block">
            El Club
          </h1>

          <p className="text-lg leading-relaxed mb-6">
            La Asociación Atlética Quimsa, con sede en Santiago del Estero, es uno de los clubes deportivos más
            emblemáticos de Argentina. Fundado en 1989 a partir de la fusión de los clubes Estudiantes Unidos,
            Inti Club y Santiago Basquetbol Club, Quimsa representa una rica historia de unión, compromiso y
            pasión por el deporte.
          </p>

          <p className="text-lg leading-relaxed mb-6">
            Desde su fundación, el club ha logrado consolidarse como referente en el básquet argentino e
            internacional. Entre sus logros más destacados se encuentran la consagración como campeón de la
            Liga Nacional de Básquet (LNB) y la obtención de la Basketball Champions League Americas, llevando
            el nombre de Santiago del Estero a lo más alto.
          </p>

          <div className="grid md:grid-cols-2 gap-10 mt-10">
            <div>
              <h2 className="text-2xl font-semibold text-blue-800 mb-4">Misión</h2>
              <p className="text-lg leading-relaxed">
                Fomentar la práctica del deporte con valores de respeto, trabajo en equipo y excelencia,
                brindando oportunidades de desarrollo humano y deportivo para niños, jóvenes y adultos.
              </p>
            </div>
            <div>
              <h2 className="text-2xl font-semibold text-blue-800 mb-4">Visión</h2>
              <p className="text-lg leading-relaxed">
                Ser un club modelo en la formación integral de atletas y ciudadanos, líder en el ámbito
                deportivo nacional e internacional, manteniendo un fuerte compromiso social con nuestra
                comunidad.
              </p>
            </div>
          </div>

          <div className="mt-16 text-center">
            <img
              src={fachadaImg}
              alt="Fachada del club"
              className="rounded-xl shadow-lg w-full max-h-[500px] object-cover"
            />
            <p className="text-sm text-gray-500 mt-2">Fachada institucional de la Asociación Atlética Quimsa</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Club;
